var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.75 9.18738C15.75 9.46352 15.5261 9.68738 15.25 9.68738L10.2498 9.68738C9.97367 9.68738 9.74981 9.46352 9.74981 9.18738L9.74981 4.18719C9.74981 3.91105 9.97367 3.68719 10.2498 3.68719L15.25 3.68719C15.5261 3.68719 15.75 3.91105 15.75 4.18719L15.75 9.18738Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.4375 9.18738C8.4375 9.46352 8.21364 9.68738 7.9375 9.68738L2.93731 9.68738C2.66117 9.68738 2.43731 9.46352 2.43731 9.18738L2.43731 4.18719C2.43731 3.91105 2.66117 3.68719 2.93731 3.68719L7.9375 3.68719C8.21364 3.68719 8.4375 3.91105 8.4375 4.18719L8.4375 9.18738Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 39",
    d: "M7.5 9.5L5 14.5",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 40",
    d: "M14.8 9.5L12.3 14.5",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.2ee15f22dc04d71b6b24466f036fbc0e.svg";
export { ForwardRef as ReactComponent };